import ApiClient from "./ApiClient";

export const getTournaments = ({ team, from, till, event, opponent, page = 1, per_page = 1000 }) =>
  ApiClient.get(`/tournaments`, {
    params: {
      team: team ? team : null,
      from: from ? from : null,
      till: till ? till : null,
      event: event ? event : null,
      opponent: opponent ? opponent : null,
      page: page,
      per_page: per_page
    }
  });
